import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'resetManyCampaignCodes'

export default (codeIds) => (asyncAction(
  name,
  CampaignsService.resetManyCampaignCodes,
  { codeIds }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/resetManyCampaignCodes.js